<button
  type="button"
  class="relative flex h-12 items-center justify-center gap-2 rounded-xl border-neutrals-500 bg-neutrals-0 px-[15px] py-2 cursor-pointer md:px-4"
  [attr.aria-label]="accessibleLabel"
  (click)="clicked.emit()"
>
  <!-- Figma 7644:7824: icon-only 56×48 below md; the label stays for screen
       readers through the button's aria-label. -->
  <ui-paragraph
    class="hidden whitespace-nowrap md:block"
    type="p14"
    mobile-type="p12"
    font-weight="medium"
    text-color="neutrals-900"
    [content]="label"
  />
  <ui-icon
    class="shrink-0"
    name="filter-alt"
    size="24"
    mobile-size="24"
    fill="neutrals-900"
  ></ui-icon>
  <span
    *ngIf="hasCount"
    class="absolute -right-0.5 -top-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-feedback-error-default"
  >
    <ui-paragraph
      type="p10"
      mobile-type="p10"
      font-weight="semibold"
      text-color="neutrals-0"
      [content]="count.toString()"
    />
  </span>
</button>
